import { Injectable } from '@angular/core';
@Injectable()
export class EventBus {
  private readonly eventEmitter;

  constructor() {
    this.eventEmitter = eventBus;
  }

  public emit(event: string, data?: unknown) {
    if (this.eventEmitter && this.eventEmitter.emit) {
      this.eventEmitter.emit(event, data);
    }
  }
}
